(function () {
    "use strict";

    // NOTICE: When instantiating a habil-email-field, only add required=true when really required
    angular.module("app").directive("habilEmailField", HabilEmailFieldDirective);

    HabilEmailFieldDirective.$inject = [];
    function HabilEmailFieldDirective() {
        return {
            templateUrl: "@/textField/email-field.html",
            transclude: true,
            require: { ngModelCtrl: "^ngModel", ngFormCtrl: "^form" },
            scope: {
                required: "=?",
                isReadonly: "=",
                onValidEmailEntered: "=?",
                object: "=?"
            },
            link: link
        };

        function link(scope, element, attributes, ctrl) {

            if (attributes.inputId) {
                element.children("input").attr("id", attributes.inputId);
            }

            // The NgModelController used for hooking into the angular model and form
            const ngModelCtrl = ctrl.ngModelCtrl;
            const ngForm = ctrl.ngFormCtrl;

            scope.form = ngForm;

            // #region Value handler

            ngModelCtrl.$render = () => {
                scope.ngModel = ngModelCtrl.$viewValue;
            };

            // External changes
            scope.$watch(function () { return scope.ngModel; }, function (newValue, oldValue) {
                // Only set the view value and invoke the callback if a new value is set, otherwise the callback is invoked on load
                if (newValue != oldValue) {
                    console.log("Setting viewvalue");
                    ngModelCtrl.$setViewValue(newValue);

                    if (ngModelCtrl.$valid) {
                        invokeCallback();
                    }
                }
            });

            // #endregion

            function invokeCallback() {
                if (angular.isFunction(scope.onValidEmailEntered))
                    scope.onValidEmailEntered(scope.object);
            }
        }
    }
})();